/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  function initStickyAddToCartBar() {
    var stickyBar = document.querySelector('[data-sticky-atc-bar]');
    var mainButton = document.querySelector('.product-form__buy-buttons');

    if (!stickyBar || !mainButton || !('IntersectionObserver' in window) || stickyBar.dataset.observed === 'true') {
      return;
    }

    stickyBar.dataset.observed = 'true';

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      });
    }, { threshold: 0 });

    observer.observe(mainButton);
  }

  document.addEventListener('DOMContentLoaded', initStickyAddToCartBar);
  document.addEventListener('variant:changed', initStickyAddToCartBar);
})();

(function () {
  // The rotator's items are all position:absolute (stacked for the cross-
  // fade), so none of them contribute intrinsic width/height to the
  // container — that's fine in a block layout (mobile), but collapses to
  // zero in the header's flex row (desktop), making the bar disappear there.
  // Measuring the real text size in JS and applying it as an explicit pixel
  // size avoids guessing a fixed height (which was clipping items
  // asymmetrically) and keeps the bar visible in both layouts.
  function measureAndSizeRotator(rotator, items) {
    var maxWidth = 0;
    var maxHeight = 0;

    items.forEach(function (item) {
      maxWidth = Math.max(maxWidth, item.scrollWidth);
      maxHeight = Math.max(maxHeight, item.scrollHeight);
    });

    rotator.style.width = maxWidth + 'px';
    rotator.style.height = maxHeight + 'px';
  }

  function initAnnouncementBarRotation() {
    document.querySelectorAll('.announcement-bar__rotator').forEach(function (rotator) {
      if (rotator.dataset.rotationInitialized === 'true') {
        return;
      }

      var items = Array.prototype.slice.call(rotator.querySelectorAll('.announcement-bar__rotator-item'));

      if (!items.length) {
        return;
      }

      rotator.dataset.rotationInitialized = 'true';
      measureAndSizeRotator(rotator, items);

      var resizeTimeout;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
          measureAndSizeRotator(rotator, items);
        }, 150);
      });

      if (items.length < 2) {
        return;
      }

      var speed = (parseFloat(rotator.dataset.rotationSpeed) || 4) * 1000;
      var current = 0;

      setInterval(function () {
        items[current].classList.remove('is-active');
        current = (current + 1) % items.length;
        items[current].classList.add('is-active');
      }, speed);
    });
  }

  document.addEventListener('DOMContentLoaded', initAnnouncementBarRotation);
})();

